import { all } from "redux-saga/effects";
import postFeedBack from "./postFeedBack";

export const feedBackPageSaga = function* root() {
	yield all([postFeedBack()]);
};
